import { useMemo } from 'react';
import {
  isCustomSupplier,
  type BBOrCustomSupplier,
} from '@bridebook/web/lib/supplier/hooks/query/use-supplier';
import type { IDatePicker } from '@bridebook/models/source/models/Weddings.types';
import { buildHotelPlannerUrl } from './get-hotel-planner-url';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';

type Params = {
  supplier?: BBOrCustomSupplier | null;
  weddingDate?: IDatePicker | null;
};

export const useHotelPlannerUrl = ({ supplier, weddingDate }: Params) => {
  const market = useMarket();
  return useMemo(() => {
    if (!supplier || isCustomSupplier(supplier)) {
      // No venue or custom venue: omit location params
      return buildHotelPlannerUrl({ weddingDate, market });
    }
    const city = supplier.address?.city;
    const latitude = supplier.coordinates?.latitude ?? (supplier.coordinates as any)?._latitude;
    const longitude = supplier.coordinates?.longitude ?? (supplier.coordinates as any)?._longitude;
    const country = supplier.address?.country;

    return buildHotelPlannerUrl({ weddingDate, city, latitude, longitude, country, market });
  }, [weddingDate, supplier, market]);
};

export default useHotelPlannerUrl;
